import { useEffect } from "react";
import Heading from "../../../../../core/ui/Heading.component";

interface CoastVerifyEmailSuccessProps {
  email: string;
}

export const CoastVerifyEmailSuccess = ({ email }: CoastVerifyEmailSuccessProps) => {
  useEffect(() => {
    // this page is much shorter than the previous
    // need to scroll to top or else this content will be out of view
    if (typeof window !== undefined) {
      window.scrollTo({ top: 0 });
    }
  }, []);

  return (
    <div className="component-coast-verify-email-success">
      <p className="step-indicator">Step 2 of 7</p>

      <Heading level={2} className="section-title">
        Verify your email
      </Heading>

      <p className="section-info">
        We sent an email to <strong>{email}</strong>. &nbsp; Please check your email and verify your account to continue
        the subscription process. &nbsp; If you don’t see our email, check your junk folder.
      </p>
    </div>
  );
};
